"use strict";

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountRestrictionsInfo = void 0;
/**
 * Account restrictions structure describes restriction information for an account.
 */

var AccountRestrictionsInfo = /*#__PURE__*/_createClass(
/**
 * Constructor
 * @param meta
 * @param accountRestrictions
 */
function AccountRestrictionsInfo(
/**
 * meta
 */
meta,
/**
 * Restrictions.
 */
accountRestrictions) {
  _classCallCheck(this, AccountRestrictionsInfo);

  this.meta = meta;
  this.accountRestrictions = accountRestrictions;
});

exports.AccountRestrictionsInfo = AccountRestrictionsInfo;